// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dd6eb56b","455":"4ab77a70","977":"1d5936b7"}[chunkId] + ".chunk.js";
};